import { CharacterType, CharacterSmallImageMap, CharacterSmallGrayImageMap, CharacterLargeImageMap, CharacterLargeGrayImageMap, CharacterDateRangeMap } from '../../enums/CharacterType';
import { isContestStage, isStudent, isTeacher, itIsMyCompetition } from './utils';

// קביעת סטטוס דמות (צבעוני/אפור)
const isCharacterUnlocked = (character, userStars, student, state, authState) => {
  if (!student || !isContestStage(state) ) 
    return true;
  return userStars >= character.fromStars;
};

// המרת שם הדמות למפתח תרגום
const getNameKey = (characterName) => {
  return `character.${characterName?.toLowerCase() ?? ''}.name`;
};

const getDescriptionKey = (characterName) => {
  return `character.${characterName?.toLowerCase()}.description`;
};



// זיהוי הדמות הנוכחית (האחרונה שהושגה) - רק לתלמיד
const getCurrentCharacter = (characters, student, state, authState) => {
  if (!student || !isContestStage(state)) 
      return null;
  const unlockedCharacters = characters.filter(c => c.isUnlocked);
  return unlockedCharacters.length > 0
    ? unlockedCharacters[unlockedCharacters.length - 1]
    : null;
};

export const buildCharacterWorldProps = (state, authState) => {
  const userStars = state?.achievements?.stars || 0;
  const student = isStudent(state);
  const charactersFromState = state?.characters || [];
  let starsRemaining = 0;

  // בניית רשימת הדמויות עם כל הנתונים
  const characters = charactersFromState.map(character => {
    const characterName = CharacterType[character.id];
    const characterId = character.id;
    const isUnlocked = isCharacterUnlocked(character, userStars, student, state, authState);
    const dateRangeValue = CharacterDateRangeMap[characterId];

    // בדיקה אם זה מפתח תרגום (מתחיל ב-"character.") או ערך ישיר
    const isDateRangeKey = typeof dateRangeValue === 'string' && dateRangeValue.startsWith('character.');

    return {
      id: characterId,
      nameKey: getNameKey(characterName),
      descriptionKey: getDescriptionKey(characterName),
      requiredStars: character.fromStars,
      cardImage: isUnlocked ? CharacterSmallImageMap[characterId] : CharacterSmallGrayImageMap[characterId],
      largeImage: isUnlocked ? CharacterLargeImageMap[characterId] : CharacterLargeGrayImageMap[characterId],
      dateRange: isDateRangeKey ? null : dateRangeValue, // ערך ישיר או null
      dateRangeKey: isDateRangeKey ? dateRangeValue : null, // מפתח תרגום או null
      isUnlocked,
      isCurrentCharacter: false, // יוגדר בהמשך
    };
  });

  // זיהוי הדמות הנוכחית
  const currentCharacter = getCurrentCharacter(characters, student, state, authState);
  if (currentCharacter !== null) {
    currentCharacter.isCurrentCharacter = true;
  }

  // קביעת דמות ברירת מחדל
  const defaultCharacterId = currentCharacter?.id ?? characters[0]?.id;

  // חישוב starsRemaining
  const nextCharacter = characters.find(c => !c.isUnlocked);
  starsRemaining = nextCharacter
    ? Math.max(0, nextCharacter.requiredStars - userStars)
    : 0;

  let button = null;
  let showStarsInfo =  false;
  let showTeacherDecorations =  true;
  if (isContestStage(state) && isStudent(state) && itIsMyCompetition(state, authState)){
    button = { "type": "play" };
    showStarsInfo =   true ;
    showTeacherDecorations = false 
  }
  if(isTeacher(state)){
    showTeacherDecorations = true;
  }

  return {
    characters,
    defaultCharacterId,
    userStars,
    starsRemaining,
    button: button,
    showStarsInfo: showStarsInfo,
    showTeacherDecorations: showTeacherDecorations,
  };
};
